export default __webpack_public_path__ + "static/media/globeautenticationmobile.c99ae9a0.png";